// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bivariate-break-labels,
.em-bivariate-tick,
.em-bivariate-frame,
.em-bivariate-nodata,
.em-bivariate-arrowhead,
.em-bivariate-axis-arrow {
    fill: #696969;
}
.em-bivariate-corner-annotation-line,
.em-bivariate-tick {
    stroke: #696969;
}
.em-bivariate-nodata-label {
    font-size: 14px;
    dominant-baseline: middle;
}
.em-bivariate-tick-label {
    text-anchor: middle;
    font-size: 12px;
}
.em-bivariate-axis-title {
    font-size: 14px;
    fill: #696969;
}
.em-bivariate-axis-arrow {
    stroke-width: 1.5;
    stroke: #696969;
}
.em-bivariate-arrowhead {
    fill: #696969;
}
.em-bivariate-axis-end-label {
    font-size: 11px;
    fill: #696969;
}
.em-bivariate-tick {
    stroke-width: 1;
}

.em-bivariate-frame {
    fill: none;
}
.em-bivariate-nodata {
    stroke-width: 0.5;
    cursor: pointer;
}
.em-bivariate-corner-annotation-line {
    stroke-width: 0.8;
    fill: none;
}
.em-bivariate-corner-annotation {
    font-size: 11px;
    fill: #696969;
}
`, "",{"version":3,"sources":["webpack://./src/css/legend/bivariate-choropleth.css"],"names":[],"mappings":"AAAA;;;;;;IAMI,aAAa;AACjB;AACA;;IAEI,eAAe;AACnB;AACA;IACI,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,eAAe;IACf,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,eAAe;IACf,aAAa;AACjB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,eAAe;IACf,aAAa;AACjB","sourcesContent":[".bivariate-break-labels,\r\n.em-bivariate-tick,\r\n.em-bivariate-frame,\r\n.em-bivariate-nodata,\r\n.em-bivariate-arrowhead,\r\n.em-bivariate-axis-arrow {\r\n    fill: #696969;\r\n}\r\n.em-bivariate-corner-annotation-line,\r\n.em-bivariate-tick {\r\n    stroke: #696969;\r\n}\r\n.em-bivariate-nodata-label {\r\n    font-size: 14px;\r\n    dominant-baseline: middle;\r\n}\r\n.em-bivariate-tick-label {\r\n    text-anchor: middle;\r\n    font-size: 12px;\r\n}\r\n.em-bivariate-axis-title {\r\n    font-size: 14px;\r\n    fill: #696969;\r\n}\r\n.em-bivariate-axis-arrow {\r\n    stroke-width: 1.5;\r\n    stroke: #696969;\r\n}\r\n.em-bivariate-arrowhead {\r\n    fill: #696969;\r\n}\r\n.em-bivariate-axis-end-label {\r\n    font-size: 11px;\r\n    fill: #696969;\r\n}\r\n.em-bivariate-tick {\r\n    stroke-width: 1;\r\n}\r\n\r\n.em-bivariate-frame {\r\n    fill: none;\r\n}\r\n.em-bivariate-nodata {\r\n    stroke-width: 0.5;\r\n    cursor: pointer;\r\n}\r\n.em-bivariate-corner-annotation-line {\r\n    stroke-width: 0.8;\r\n    fill: none;\r\n}\r\n.em-bivariate-corner-annotation {\r\n    font-size: 11px;\r\n    fill: #696969;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
